<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{form.main.bm_vend_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月份</label>
            <span class="weui-form-preview__value">{{form.main.bm_year_month}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in form.items" :key="item.id">
          <div class="form-detail-preview_num">{{index + 1}}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{bd_source_type(item.bd_source_type)}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来源单号</label>
            <span class="weui-form-preview__value">{{item.bd_source_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库单号</label>
            <span class="weui-form-preview__value">{{item.bd_pi_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行号</label>
            <span class="weui-form-preview__value">{{item.bd_pi_pd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收料数量</label>
            <span class="weui-form-preview__value">{{item.bd_iqc_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">验退数量</label>
            <span class="weui-form-preview__value">{{item.bd_iqc_ngqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库数量</label>
            <span class="weui-form-preview__value">{{item.bd_pi_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库日期</label>
            <span class="weui-form-preview__value">{{item.bd_pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.bd_source_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.bd_pi_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{item.bd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.bd_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.bd_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.bd_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.bd_pr_brand}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <share class="weui-dialog__btn weui-dialog__btn_default" v-if="!editable" :biz-data="bizData"></share>
    </div>
  </div>
</template>

<script>
import Share from "@/components/button/Share.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    Share
  },
  mixins: [process],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(!to.params.item)to.params.item = from.params.item || null // 兼容返回到本页
      if (to.params.id || to.query.id) {
        vm.f_get();
      } else if (to.params.initData) {
        // 通过路由传initData的情况
        vm.form = to.params.initData;
      } else if (!vm.initId && !vm.initData) {
        if (vm.originalForm) {
          vm.form = vm.$clone(vm.originalForm);
        }
      }
      // 因为router切换时页面有缓存，备份一下初始化form参数
      if (!vm.originalForm) {
        vm.originalForm = vm.$clone(vm.form);
      }
    });
  },
  data() {
    return {
      baseUrl: "/api/purchase/purchaseBill",
      codeField: "code",
      caller: "PurchaseBill"
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        // bizCode: main.pu_code,
        bizType: "PurchaseBill",
        bizId: main.id,
        viewType: "purchase-purchaseReconciliation-querypanel-detail",
        title: "采购对账明细表" + main.bm_year_month,
      };
    },
  },
  methods: {
    bd_source_type(type) {
      type = type.toUpperCase()
      if(type == 'OSMAKEIN'){
        type = "外协入库";
      } else if (type == 'OSMAKEINBACK'){
        type = "外协退货";
      } else if (type == 'OthPayables'){
        type = "应付调账单";
      } else if (type == 'PURCOUT'){
        type = "采购退货";
      } else if (type == 'PURCIN'){
        type = "采购入库"
      }
      return type;
    }
  }
}
</script>